import React from "react";
import { Link } from "react-router-dom";
import StepBadge from "./StepBadge";
import ApplyCards from "./ApplyCards";
import FaqList from "./FaqList";

function HeroSection({ onApplyClick }) {
  return (
    <main className="flex min-h-0 flex-1 flex-col items-center justify-center overflow-y-auto px-3 py-6 sm:px-4">
      <div className="mx-auto w-full max-w-[min(100%,1200px)]">
        <h1 className="text-center text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl">
          Quality education for every bright child.
        </h1>

        <p className="mt-2 text-center text-sm text-slate-600">
          Click below to apply via SMS to <strong>22351</strong> with Admission
          No, Full Name, School.
        </p>

        <div className="mt-5 flex flex-wrap items-center justify-center gap-3 text-xs text-slate-600 sm:gap-4">
          <StepBadge number={1} label="Send details to 22351" color="orange" />
          <StepBadge number={2} label="Answer SMS prompts" color="blue" />
          <StepBadge number={3} label="Get support" color="emerald" />
        </div>

        <ApplyCards onApplyClick={onApplyClick} />

        <Link
          to="/register"
          className="participate-btn mx-auto mt-8 block w-full max-w-4xl rounded-xl py-4 text-center text-base font-bold uppercase tracking-wide text-white transition focus:outline-none focus:ring-2 focus:ring-[#0057A5] focus:ring-offset-2 disabled:opacity-70"
        >
          Click here to apply
        </Link>

        <FaqList />
      </div>
    </main>
  );
}

export default HeroSection;
